import { render, staticRenderFns } from "./ExamineName.vue?vue&type=template&id=6d2ca731&scoped=true&"
import script from "./ExamineName.vue?vue&type=script&lang=js&"
export * from "./ExamineName.vue?vue&type=script&lang=js&"
import style0 from "./ExamineName.vue?vue&type=style&index=0&id=6d2ca731&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ca731",
  null
  
)

export default component.exports